import { render, staticRenderFns } from "./PagoTemplate.vue?vue&type=template&id=14c5922a&"
import script from "./PagoTemplate.vue?vue&type=script&lang=js&"
export * from "./PagoTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports